export class CredentialsError extends Error {
    constructor(message="Der Benutzername oder das Passwort ist falsch.") {
        super(message);
        this.name = 'CredentialsError';
        Object.setPrototypeOf(this, CredentialsError.prototype);
    }
}

export class UserNameInUseError extends Error {
    constructor(message="Der Benutzername wird bereits verwendet") {
        super(message);
        this.name = 'UserNameInUseError';
        Object.setPrototypeOf(this, UserNameInUseError.prototype);
    }
}

export class EmailInUseError extends Error {
    constructor(message="Die E-mail Adresse wird bereits verwendet") {
        super(message);
        this.name = 'EmailInUseError';
        Object.setPrototypeOf(this, EmailInUseError.prototype);
    }
}
